import { FLagWithText as AntdFLagWithText } from '@empglabs/backoffice-ui-kit'

export const FLagWithText = props => {
  return <AntdFLagWithText {...props} />
}
